import { REPLAY_METRIC_KEYS, type ReplayMetricKey } from "../model/types";

/**
 * KAN-876: как показывать сырое значение метрики (эпик KAN-804).
 *
 * Одна функция на ВСЕ витрины метрик, а не только на страницу итогов. Расхождение
 * здесь особенно коварно: «0.61» и «61%» — одно и то же число, показанное так, что
 * читатель считает их разными величинами, и разъезжаются копии молча.
 *
 * KAN-901: живёт в entities, а не в widgets, потому что потребители лежат в разных
 * виджетах (`tournament-results`, `tournament-detail`), а виджету запрещено
 * импортировать из соседнего виджета (`ai/module-graph.md`). Копий было три.
 *
 * Доли показываются процентами, а не сотыми: подпись единицы («полезных вардов»)
 * читается вместе с числом, и «61%» отвечает на вопрос, а «0.61» задаёт новый.
 */
export function formatMetricValue(key: ReplayMetricKey, value: number): string {
  // KAN-814: `killParticipation` тоже доля 0–1, а показывалась как «0.5» — то есть
  // как штука. Нашлось в витрине пар по ролям, но живёт в каждом потребителе этой
  // функции: одно и то же число рядом выглядело то долей, то количеством.
  if (
    key === "visionQuality" ||
    key === "goldUtilization" ||
    key === "killParticipation"
  ) {
    return `${Math.round(value * 100)}%`;
  }
  if (key === "objectiveFocus") return value.toFixed(2);
  return value >= 10 ? Math.round(value).toString() : value.toFixed(1);
}

/**
 * Ключ пришёл строкой и может оказаться не метрикой: витрина пар по ролям (KAN-763)
 * смешивает в одном списке величины табло (`cs`, `gold`) и метрики (`killParticipation`,
 * `turretPlates`). Проверка нужна, чтобы общий формат применялся ровно к общим ключам,
 * а не к похожим по виду.
 */
export function isReplayMetricKey(key: string): key is ReplayMetricKey {
  return (REPLAY_METRIC_KEYS as readonly string[]).includes(key);
}
